module.exports = __webpack_public_path__ + "static/media/CX.e566825b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CXs/images/CX.svg
// module id = 94
// module chunks = 0